import {createContext} from 'react';
import type {LocalizationContextType} from './types';
import {getLocalizationContext} from './getLocalizationContext';

export const LocalizationContext = createContext<LocalizationContextType>(
  getLocalizationContext(),
);
